module.exports = function clone(obj) {
  return JSON.parse(JSON.stringify(obj));
};



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch/src/clone.js
// module id = 14
// module chunks = 0